export enum BoatProfile{
    Recurrent = 'RECURRENT',
    Eventual = 'EVENTUAL',
    Workshop = 'WORKSHOP'
}
